import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LabelComponent from "pages/profile/common/label";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";
import { vatCertificationType } from "utils/constantValues";

function VatInformation({ onEditClick = () => {}, isShowEditIcon = false }) {
  const [t] = useTranslation();
  const [isHover, setIsHover] = useState(false);
  const userDetails = useSelector((state) => state.userDetails || {});

  const isVatExempt = !!userDetails?.flags?.isVatExempt;
  const vatCountry = userDetails?.vatCountry?.name || "-";
  const vatRegistrationNumber = userDetails?.vatRegistrationNumber || "-";
  const vatFile = (userDetails?.userFiles || []).find(
    (f) => f?.type === vatCertificationType
  );
  const vatFileName = vatFile?.name || "-";

  const user = useSelector((state) => state.user || {});
  const isLoggedInByMagicLink = user?.isAdmin ?? false;

  return (
    <div
      id="vatSection"
      className={`flex p-[24px] flex-col gap-[12px] self-stretch cursor-pointer ${
        isHover && !isLoggedInByMagicLink ? "bg-[#F3F5F7]" : ""
      }`}
      onMouseEnter={() => {
        if (!isLoggedInByMagicLink) {
          setIsHover(true);
        }
      }}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="flex justify-between items-center self-stretch">
        <div className="text-[#1D1B22] font-semibold text-[24px]">
          {t("vatExempt")}
        </div>
        {isShowEditIcon && !isLoggedInByMagicLink && (
          <EditIcon
            className={`cursor-pointer ${isHover ? "visible" : "invisible"}`}
            onClick={() => {
              if (!isLoggedInByMagicLink) {
                onEditClick();
              }
            }}
          />
        )}
      </div>

      <div className="flex flex-wrap gap-[20px]">
        <LabelComponent
          title={isVatExempt ? "" : t("vatExemptApplicable")}
          subTitle={isVatExempt ? t("Yes") : t("No")}
        />
        {!isVatExempt && (
          <>
            <LabelComponent
              title={t("vatCountry")}
              subTitle={`${vatCountry}`}
            />
            <LabelComponent
              title={t("vatRegistrationNumber")}
              subTitle={`${vatRegistrationNumber}`}
            />
            <LabelComponent
              title={t("vatCertification")}
              subTitle={`${vatFileName}`}
            />
          </>
        )}
      </div>
    </div>
  );
}

VatInformation.propTypes = {
  onEditClick: PropTypes.func,
  isShowEditIcon: PropTypes.bool,
};

export default VatInformation;
